import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { FC, useState } from 'react';
import { IconWithTooltip } from '../shared/IconWithTooltip';
import { useFormContext } from 'react-hook-form';
import clsx from 'clsx';

type IPasswordTextfieldProps = TextFieldProps & {
  nameField: string;
  customClassName?: string;
  showCopyButton?: boolean;
  disabled?: boolean;
  onChangeField?: () => void;
  buttons?: JSX.Element[];
};

export const PasswordTextfield: FC<IPasswordTextfieldProps> = (props) => {
  const { nameField, customClassName, showCopyButton = false, disabled, buttons = [] } = props;
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    formState: { errors },
    watch,
    clearErrors,
  } = useFormContext();
  const fieldValue = watch(nameField);

  // Функция для получения вложенного значения по пути
  const getNestedError = (obj: any, path: string) => {
    return path.split('.').reduce((current, key) => current?.[key], obj);
  };

  const fieldError = getNestedError(errors, nameField);

  return (
    <TextField
      {...register(nameField, {
        onChange: () => {
          if (fieldError) clearErrors(nameField);
        },
      })}
      error={!!fieldError}
      helperText={fieldError?.message as string}
      fullWidth
      variant="standard"
      className={clsx(customClassName, 'custom')}
      type={showPassword ? 'text' : 'password'}
      disabled={disabled}
      autoComplete="off"
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <>
                <IconWithTooltip
                  dataAttribute="show-secret-key"
                  muiIcon={showPassword ? VisibilityOffOutlinedIcon : VisibilityOutlinedIcon}
                  customTitle={showPassword ? 'Скрыть' : 'Показать'}
                  onClick={() => {
                    setShowPassword((show) => !show);
                  }}
                />
                {showCopyButton && (
                  <IconWithTooltip
                    dataAttribute="copy-secret-key"
                    iconType="copy"
                    onClick={() => navigator.clipboard.writeText(String(fieldValue))}
                  />
                )}
                {buttons}
              </>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
